var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "FormFieldsContainer",
        [
          _c(
            "v-flex",
            { attrs: { sm3: "", md3: "" } },
            [
              _c("DatePicker", {
                attrs: {
                  label: _vm.formFields.fechaInicio.label,
                  "error-messages": _vm.errors.collect(
                    _vm.formFields.fechaInicio.id
                  ),
                  id: _vm.formFields.fechaInicio.id,
                  min: _vm.fechaMinima,
                  max: _vm.fechaMaximaInicio.format("YYYY-MM-DD"),
                  format: "DD/MM/YYYY"
                },
                model: {
                  value: _vm.formFields.fechaInicio.value,
                  callback: function($$v) {
                    _vm.$set(_vm.formFields.fechaInicio, "value", $$v)
                  },
                  expression: "formFields.fechaInicio.value"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { sm3: "", md3: "" } },
            [
              _c("DatePicker", {
                attrs: {
                  label: _vm.formFields.fechaTermino.label,
                  "error-messages": _vm.errors.collect(
                    _vm.formFields.fechaTermino.id
                  ),
                  id: _vm.formFields.fechaTermino.id,
                  min: _vm.fechaMinimaInicio.format("YYYY-MM-DD"),
                  max: _vm.fechaMaxima,
                  format: "DD/MM/YYYY"
                },
                model: {
                  value: _vm.formFields.fechaTermino.value,
                  callback: function($$v) {
                    _vm.$set(_vm.formFields.fechaTermino, "value", $$v)
                  },
                  expression: "formFields.fechaTermino.value"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { sm4: "", md4: "" } },
            [
              _c(
                "v-text-field",
                _vm._b(
                  {
                    attrs: {
                      label: "Buscar...",
                      "single-line": "",
                      "hide-details": ""
                    },
                    model: {
                      value: _vm.query,
                      callback: function($$v) {
                        _vm.query = $$v
                      },
                      expression: "query"
                    }
                  },
                  "v-text-field",
                  Object.assign({}, _vm.$props, _vm.$attrs),
                  false
                )
              )
            ],
            1
          ),
          _c("v-flex", { attrs: { sm2: "", md2: "" } }, [
            _c(
              "div",
              { staticClass: "text-xs-center" },
              [
                _c(
                  "v-btn",
                  {
                    attrs: { flat: "", icon: "", small: "" },
                    on: { click: _vm.realizarBusqueda }
                  },
                  [_c("v-icon", [_vm._v("search")])],
                  1
                ),
                _c(
                  "v-btn",
                  {
                    attrs: { flat: "", icon: "", small: "" },
                    on: { click: _vm.limpiarBusqueda }
                  },
                  [_c("v-icon", [_vm._v("clear")])],
                  1
                )
              ],
              1
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }